import classnames from 'classnames';
import { arrayOf, bool, node, shape, string } from 'prop-types';

const ReductionReport = ({ header, rows, subHeader }) => {
  if (rows && rows.length > 0) {
    return (
      <div className="reduction-report">
        <h3>{header}</h3>
        {subHeader && <div className="subHeader">{subHeader}</div>}
        <ul>
          {rows.map(({ description, optionalLine, complete = true }) => {
            let descriptionToRender = description;
            let key = description;
            if (Array.isArray(description)) {
              descriptionToRender = description.map((line, i) => (
                <div key={i}>{line}</div>
              ));
              key = description.join(',');
            }
            return (
              <li
                key={key}
                className={classnames('row', { 'row--incomplete': !complete })}
              >
                {descriptionToRender}
                {optionalLine && (
                  <div className="optional-line">{optionalLine}</div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
  return null;
};
ReductionReport.propTypes = {
  header: string.isRequired,
  rows: arrayOf(
    shape({
      description: node.isRequired,
      optionalLine: node,
      complete: bool,
    }),
  ),
  subHeader: node,
};

export default ReductionReport;
